import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateProductPackageApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateProductPackage = createAsyncThunk('updateProductPackage', async (payload) => {
  return await updateProductPackageApi(payload);
});

const updateProductPackageSlice = createSlice({
  name: 'updateProductPackage', // Unique Name
  initialState,
  reducers: {
    updateProductPackageReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateProductPackage.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateProductPackage.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateProductPackage.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateProductPackageReset } = updateProductPackageSlice.actions;

export default updateProductPackageSlice.reducer;
